module.exports = __webpack_public_path__ + "static/media/people-asm.4f0d5247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/people-asm.svg
// module id = 267
// module chunks = 0